import {
  take,
  put,
  fork,
  cancel,
  select,
  cancelled,
  actionChannel,
} from "redux-saga/effects"

import isFunction from "lodash/isFunction"
import merge from "lodash/merge"
import devlog from "src/helpers/devlog"
import { request } from "src/engine/modules/session/effects"
import { normalize as normalizeModel } from "src/engine/modules/model/helpers"
import get from "lodash/get"
import getWordByModelName from "src/helpers/text/getWordByModelName"
import { showToast } from "@infotech/uikit-toasts"
import getWordEnding from "../helpers/getWordEnding"
import { process as selectProcess } from "../selectors"
import { types, creators } from "../actions"
import { normalize } from "../helpers"

const METHOD = `put`

function* update(action) {
  const { id, model, data } = action
  const name = get(data, `name`)

  try {
    const { getUrl, getRestUrn } = normalizeModel(model)

    const requestURL = getRestUrn ? getRestUrn(METHOD, id) : getUrl(id) // TODO: remove getUrl support

    const denormalizedData = isFunction(model.denormalize)
      ? model.denormalize(data, {
          method: METHOD,
        })
      : data

    const result = yield request(
      requestURL,
      {},
      {
        method: METHOD,
        body: denormalizedData,
      },
    )
    const { data: nextData } = result
    const normalized = normalize(nextData, model)
    const successData = merge(denormalizedData, normalized.data)

    yield put(creators.update.success(model, id, successData))

    showToast({
      type: `success`,
      message: `${getWordByModelName(model.name, false, true)} ${
        name ? `"${name}" ` : ``
      }успешно изменен${getWordEnding(model.name)}.`,
      hideIn: 5,
    })
  } catch (error) {
    devlog(error)
    yield put(creators.update.error(model, id, error))
  } finally {
    if (yield cancelled()) {
      yield put(creators.update.cancel(model, id))
    }
  }
}

export default function* updateSaga() {
  const updateRequest = yield actionChannel([types.update, types.updateCancel])
  while (true) {
    const action = yield take(updateRequest)

    const { id, model } = action

    const process = yield select(selectProcess, model, id)

    if (action.type === types.update) {
      // Detect current action is works
      if (process) {
        switch (process.type) {
          // Cancel previous, if it's read
          case types.read:
          case types.update:
            yield cancel(process.task)
            break
          // Impossible action
          case types.create:
            throw new Error(`Illegal action type of current process`)
          // Drop error, if it's removing
          case types.remove:
            throw new Error(`You can update removing entity`)
          // Drop error if it's removing
          default:
            throw new Error(`Unknown entity action type founded`)
        }
      }
      const task = yield fork(update, action)
      yield put(creators.processing.start(types.update, task, model, id))
      yield fork(function* watchFork() {
        yield task.toPromise()
        yield put(creators.processing.complete(types.update, task, model, id))
      })
      // If fetch completed, we should erase existen progress
    } else if (action.type === types.updateCancel) {
      if (process) {
        const { task } = process
        if (process.type === types.update) {
          yield cancel(task)
        } else {
          throw new Error(
            `Unexpected cancellation of process with another task`,
          )
        }
      }
    }
  }
}
